export const GET_AMENITIES_LIST = 'GET_AMENITIES_LIST';
export const SET_ACTIVE_AMENITY_AREA = 'AMENITY_AREA_ACTIVE';
export const SET_ACTIVE_AMENITY = 'SET_AMENITY_ACTIVE';
